import { Injectable, Injector }     from '@angular/core';
import { BaseService }              from './base.service';
import { HttpClient }               from '@angular/common/http';
import { timeout, map }             from 'rxjs/operators';
import { Observable }               from 'rxjs';
import ZimbraInstanceSearch         from '../models/ZimbraInstanceSearch';
import { UtilityService }           from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class ZimbraInstanceService extends BaseService {

  constructor(private httpClient: HttpClient , injector: Injector) 
  { 
    super();
    
    this.url_params["zimbrainstance"]           = "zimbrainstance/";
    this.url_params["get_zimbrainstance"]       = "zimbrainstance/:id/";
    this.url_params["zimbra_login"]             = "zimbrainstance/zimbra_login/";
    
  }
  
  getZimbraInstance(zimbrainstance_id)
  {
    return this.httpClient.get<any>(this.getApiUrl() + this.url_params["get_zimbrainstance"].replace(":id",zimbrainstance_id)).pipe(timeout(15000)).pipe(map((response: any) => response));
  }

  getZimbraInstances(zimbrainstance_search : ZimbraInstanceSearch , per_page = null, page_number = null , procedure_info = null, serialize_filter = {}): Observable<any>
  {
    var params = this.buildSearchParams(zimbrainstance_search , per_page, page_number, procedure_info, serialize_filter);
    return this.httpClient.get<any>(this.getApiUrl() + this.url_params["zimbrainstance"],{ params }).pipe(map((response: any) => response));
  }
  
  saveZimbraInstance(zimbrainstance) : Observable<any>
  {
    return this.httpClient.post(this.getApiUrl() + this.url_params["zimbrainstance"], { "zimbrainstance" : zimbrainstance } ).pipe(map((response: any) => response))
  }
  
  updateZimbraInstance(zimbrainstance): Observable<any>
  {
    return this.httpClient.put(this.getApiUrl() + this.url_params["get_zimbrainstance"].replace(":id",zimbrainstance["id"]), { "zimbrainstance" : zimbrainstance } ).pipe(map((response: any) => response))
  }
  
  deleteZimbraInstance(pk)
  {
    return this.httpClient.delete(this.getApiUrl() + this.url_params["get_zimbrainstance"].replace(":id",pk)).pipe(map((response: any) => response))
  }

  zimbraLogin()
  {
    return this.httpClient.post(this.getApiUrl() + this.url_params["zimbra_login"], { } ).pipe(map((response: any) => response))
  }
  

}
